<script>
    import {onMount} from 'svelte';
    import rpcjs from 'rpcjs';
    const {title, goto} = rpcjs.props;
    title.set('Future Of Gaming');
    onMount(onMountFunction);
    /**
     */
    function onMountFunction() {
        setTimeout(startAni, 1000);
    }
    /**
     */
    function startAni() {
        pinkDiv.style.width = '43.177vw';
        pinkDiv.style.height = '51.583vh';
        pinkDiv.style.transition = '1.2s';
        pinkDiv.style.right = '2.813vw';
        boxinnertext1 = 'boxinnertext1';
        pinkDiv.style.borderRadius = '0px 0px 2.083vw 2.083vw';
        rightDiv.style.right = '50vw';
        rightDiv.style.transition = '1s';
        rightDiv.style.bottom = '3.542vw';
        rightdivtext2 = 'rightdivtext2';
        leftText.style.opacity = '0';
        leftText.style.transition = '1s';
    }
    const text = [
        {
            innertext: 'NON-TECHNICAL',
        },
        {
            innertext: 'NARRATIVE DRIVEN',
        },
        {
            innertext: 'REAL TIME',
            Clr: 'aqua',
        },
        {
            innertext: 'ENSEMBLE',
        },
        {
            innertext: 'ONLINE-FIRST',
        },
        {
            innertext: 'LIGHTWEIGHT',
        },
        {
            innertext: 'MULTIPLAYER',
        },
        {
            innertext: 'PHOTOREALISTIC',
        },
        {
            innertext: 'LIMITLESS',
        },
    ];
    let backImg = 'images/futureofgaming/backpic1.png';
    let pinkDiv;
    let rightDiv;
    let leftText;
    let pinkdivafter;
    let boxinnertext1;
    let box1after;
    let box2after;
    let box3after;
    let box4after;
    let box5after;
    let box6after;
    let box7after;
    let box8after;
    let backImgafter;
    let rightdivtext2 = 'rightdivtext';
    let text1 = 0;
    let whiteDiv;
    /**
     */
    function onStart() {
        whiteDiv.style.left = '-100vw';
    }
    onMount(onMountFunctio);
    /**
     */
    function onMountFunctio() {
        setTimeout(onStart, 10);
    }
    /**
     * Adds two numbers together.
     */
    function next() {
        text1++;
        if (text1 == 1) {
            backImg = 'images/futureofgaming/backpic2.png';
            boxinnertext1 = 'boxinnertext2';
            pinkdivafter = 'pinkdivafter1';
            box1after = 'box1after';
        } else if (text1 == 2) {
            backImg = 'images/futureofgaming/backpic3.png';
            pinkdivafter = 'pinkdivafter2';
            box1after = 'box1';
            box2after = 'box2after';
        } else if (text1 == 3) {
            backImg = 'images/futureofgaming/backpic4.png';
            pinkdivafter = 'pinkdivafter3';
            box2after = 'box2after2';
            box3after = 'box3after';
        } else if (text1 == 4) {
            backImg = 'images/futureofgaming/backpic5.png';
            backImgafter = 'backImgafter';
            pinkdivafter = 'pinkdivafter4';
            box3after = 'box3';
            box4after = 'box4after';
        } else if (text1 == 5) {
            pinkdivafter = 'pinkdivafter4';
            box4after = 'box4';
            backImg = 'images/futureofgaming/backpic6.png';
            backImgafter = 'backImgafter2';
            box5after = 'box5after';
        } else if (text1 == 6) {
            pinkdivafter = 'pinkdivafter5';
            backImg = 'images/futureofgaming/backpic7.png';
            backImgafter = 'backImg';
            box5after = 'box5after2';
            box6after = 'box6after';
        } else if (text1 == 7) {
            pinkdivafter = 'pinkdivafter6';
            backImg = 'images/futureofgaming/backpic8.png';
            box6after = 'box6';
            box7after = 'box7after';
        } else if (text1 == 8) {
            pinkdivafter = 'pinkdivafter4';
            backImg = 'images/futureofgaming/backpic9.png';
            box8after = 'box8after';
            box7after = 'box7';
        } else if (text1 > 8) {
            goto('/opusWeb3');
        }
    }
    /**
     * Adds two numbers together.
     * @param {int} e The first number.
     */
    function keycheck(e) {
        e.preventDefault();
        if (e.key == 'ArrowRight') {
            next();
        }
        if (e.key == 'ArrowLeft') {
            goto('/videoGaming');
        }
    }
</script>

<svelte:window on:keyup={keycheck}/>

<section>
    <div class='whiteDiv' bind:this={whiteDiv} />
    <div class='main-div' role='presentation' on:click={next} >
        <div
            class="backImg {backImgafter}"
            role="presentation"
            on:click={() => {
                if (text1 === 8) {
                    goto('/opusWeb3');
                }
            }}
        >
            <img class="img" src={backImg} alt="" />
        </div>
        <div class="pinkdiv {pinkdivafter}" bind:this={pinkDiv} />
        <div class="boxinnertext {boxinnertext1}">
            <p class="pinkdivtext1">No technical knowledge required.</p>
            <p class="pinkdivtext2">
                Building an ecosystem for narrative driven video games <br /> for
                non-technical creators
            </p>
        </div>

        <div class="left-text" bind:this={leftText}>
            <p>the future of gaming is</p>
        </div>
        <div class="right-text" bind:this={rightDiv}>
            {#each text as data, i}
                <p class={i === text1 ? 'color' : 'color2'} id={rightdivtext2}>
                    {data.innertext}
                </p>
            {/each}
        </div>
        <div class="box1 {box1after}">
            <div class="box1text" style="text-align:center;">
                <p>Adding a scene is as simple as writing the narrative.</p>
                <p>
                    A 5 minute tutorial is all a creator needs to get started.
                </p>
            </div>
        </div>
        <div class="box2 {box2after}">
            <div class="box2text" style="text-align:left;">
                <p>
                    Have a revolutionary game idea in the middle of the night?
                </p>
                <p>
                    The prototype can be completed before dawn, tweaked over the
                    weekend and published within a week.
                </p>
            </div>
        </div>
        <div class="box3 {box3after}">
            <div class="box3text" style="text-align:left;">
                <p>Not a tool or a model but afull-cycle platform</p>
                <div class="box3innerdiv">
                    <p>Ideation</p>
                    <p>Publishing</p>
                    <p>Distribution</p>
                </div>
            </div>
        </div>
        <div class="box4 {box4after}">
            <div class="box4text" style="text-align:left;">
                <p>
                    Traditional game-tech workflow starts by downloading a
                    plethora of tools.
                </p>
                <p>Think Photoshop vs Figma or Office vs Google Docs.</p>
                <p>
                    Opus creates new opportunities for team collaboration,
                    faster release cycles and subscription based pricing.
                </p>
            </div>
        </div>
        <div class="box5 {box5after}">
            <p>
                To get started, the only requirement is a good internet
                connection and an entry-tier PC/Mac or a smartphone.
            </p>
        </div>
        <div class="box6 {box6after}">
            <p>Natively Multiplayer</p>
            <p>Cooperative or competitive</p>
        </div>
        <div class="box7 {box7after}">
            <p>
                OPUS provides SSR by default which runs the published games at
                optimal settings.
            </p>
            <p>Only download for competitive multiplayer.</p>
        </div>
        <div
            class="box8 {box8after}"
            role="presentation"
            on:click={() => {
                goto('/opusWeb3');
            }}
        >
            <p>Fan fiction or github for games.</p>
            <p>
                As a creator, you can allow others to derive from your creation.
            </p>
            <p>
                Add a side quest or an entire expansion. Add depth to
                characters,<span style="font-weight: 600;font-style: italic;">
                    the narrative is the limit.</span
                >
            </p>
        </div>
    </div>
</section>

<style>
    section {
        position: relative;
    }
    .img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: right;
        position: relative;
    }
    .whiteDiv {
        position: absolute;
        background-color: white;
        width: 100%;
        height: 100vh;
        overflow: hidden;
        top: 0;
        left: 0vw;
        z-index: 4;
        transition-duration: 0.6s;
    }
    .color {
        color: #ff007f;
        font-size: 4.167vw !important;
        line-height: 3.517vw !important;
    }
    .color2 {
        color: rgba(255, 255, 255, 0.16);
    }
    .main-div {
        width: 100%;
        height: 100vh;
        position: relative;
        overflow: hidden;
        background-color: #101428;
    }
    #rightdivtext {
        color: rgba(255, 255, 255, 0.8);
        font-family: "Montserrat";
        margin: 0;
        font-size: 5.208vw;
        font-weight: 900;
        line-height: 4.396vw;
    }
    #rightdivtext2 {
        font-size: 3.125vw;
        line-height: 2.638vw;
        transition: 1.2s;
        font-family: "Montserrat";
        margin: 0;
        font-weight: 900;
    }
    .left-text p {
        color: rgba(16, 20, 40, 1);
        font-family: "Montserrat";
        margin: 0;
        font-size: 5.208vw;
        font-weight: 900;
        line-height: 4.396vw;
        text-transform: uppercase;
    }
    .right-text {
        width: 50vw;
        right: 5.573vw;
        position: absolute;
        bottom: 1vw;
    }
    .left-text {
        width: 31.615vw;
        text-align: right;
        left: 4.74vw;
        position: absolute;
        bottom: 1vw;
    }
    .backImg {
        width: 100vw;
        height: 100vh;
        position: absolute;
    }
    .backImgafter {
        width: 100vw;
        height: 100vh;
        position: absolute;
        /* left: -3.333vw;
        bottom: -4.948vw; */
        background-color: #041115;
    }
    /* -------------------------------------------------------------------
    ------------------------------------------------------------------- */
    .backImgafter2 {
        width: 43.958vw;
        height: 56.25vw;
        position: absolute;
        top: 2.083vw;
        right: 18.646vw;
        z-index: 1;
    }

    .pinkdiv {
        width: 100%;
        height: 100%;
        position: absolute;
        background-color: #ff007f;
        top: 0vw;
    }
    .pinkdiv0 {
        width: 43.177vw;
        height: 34.583vw;
        position: absolute;
        background-color: #ff007f;
        top: 0vw;
        right: 2.813vw;
        transition: 1.2s;
    }
    .pinkdivafter1 {
        top: 50vh;
        border-radius: 2.083vw 2.083vw 0px 0px !important;
        transition: 1s;
    }
    .pinkdivafter2 {
        height: 27.813vw !important;
        top: 0vw;
        border-radius: 0px 0px 2.083vw 2.083vw !important;
        transition: 1s;
    }
    .pinkdivafter3 {
        height: 39.479vw !important;
        top: 0vw;
        border-radius: 0px 0px 2.083vw 2.083vw !important;
        transition: 1s;
    }
    .pinkdivafter4 {
        width: 37.969vw !important;
        height: 100% !important;
        top: 0vw;
        border-radius: 0px 0px 0px 0px !important;
        transition: 0.5s !important;
    }
    .pinkdivafter5 {
        width: 37.969vw !important;
        height: 27.917vw !important;
        top: 0vw;
        border-radius: 0px 0px 2.083vw 2.083vw !important;
        transition: 1s !important;
    }
    .pinkdivafter6 {
        width: 37.969vw !important;
        height: 61.427vh !important;
        top: 39vh;
        border-radius: 2.083vw 2.083vw 0px 0px !important;
        transition: 1s !important;
    }
    .pinkdivtext1 {
        font-size: 4.167vw;
        font-weight: 900;
        color: white;
        font-family: "Montserrat";
        line-height: 3.438vw;
        text-transform: uppercase;
        margin: 0;
    }
    .pinkdivtext2 {
        font-size: 2.083vw;
        font-weight: 400;
        color: white;
        font-family: "Montserrat";
        line-height: 2.5vw;
    }
    .box1text p:nth-child(1) {
        font-size: 2.083vw;
        font-weight: 700;
        color: white;
        font-family: "Montserrat";
        line-height: 2.5vw;
        margin: 0;
    }
    .box1text p:nth-child(2) {
        font-size: 2.083vw;
        font-weight: 700;
        color: white;
        font-family: "Montserrat";
        line-height: 2.5vw;
        margin-bottom: 0;
    }
    .box2text p:nth-child(1) {
        font-size: 2.604vw;
        font-weight: 700;
        color: white;
        font-family: "Montserrat";
        line-height: 3.125vw;
        margin: 0;
    }
    .box2text p:nth-child(2) {
        font-size: 1.563vw;
        font-weight: 400;
        color: white;
        font-family: "Montserrat";
        line-height: 1.875vw;
        margin-bottom: 0;
    }
    .boxinnertext {
        width: 34.01vw;
        margin: auto;
        position: absolute;
        right: 6.6vw;
        top: -26vw;
        font-size: 2.083vw;
        font-weight: 400;
        color: white;
        font-family: "Montserrat";
        line-height: 2.5vw;
        transition: 1s;
        z-index: 1;
    }
    .boxinnertext1 {
        top: 6vh;
        transition: 1s;
        transition-delay: 0.5s;
    }
    .boxinnertext2 {
        top: -76vw;
        transition: 1s;
    }
    .box1 {
        z-index: 1;
        position: absolute;
        bottom: -13.073vw;
        right: 8.698vw;
        width: 31.406vw;
        height: 12.5vw;
        transition: 1s;
    }
    .box1after {
        bottom: 6.927vw;
        transition: 1s;
    }
    .box2 {
        z-index: 1;
        position: absolute;
        top: 8.021vw;
        right: 8.698vw;
        width: 32.031vw;
        height: fit-content;
        opacity: 0;
    }
    .box2after {
        opacity: 1;
        transition: 1s;
        transition-delay: 0.2s;
    }
    .box2after2 {
        top: -18vw;
        transition: 0.8s;
    }
    .box3 {
        z-index: 1;
        position: absolute;
        top: -25.979vw;
        right: 5.417vw;
        width: fit-content;
        height: fit-content;
        opacity: 1;
        transition: 1s;
    }
    .box3after {
        top: 8.021vw;
        transition: 1s;
    }
    .box3innerdiv {
        display: flex;
        margin-top: 5.052vw;
        width: 36.51vw;
        justify-content: space-between;
    }

    .box3innerdiv p {
        font-size: 1.563vw;
        font-weight: 700;
        color: white;
        font-family: "Montserrat";
        line-height: 2.336vw;
        margin: 0;
        text-transform: uppercase;
        position: relative;
    }
    .box3innerdiv > p:nth-child(2)::after {
        content: "";
        position: absolute;
        width: 0.052vw;
        height: 4.792vw;
        background-color: white;
        bottom: -1.2vw;
        right: -1.563vw;
    }
    .box3innerdiv > p:nth-child(2)::before {
        content: "";
        position: absolute;
        width: 0.052vw;
        height: 4.792vw;
        background-color: white;
        bottom: -1.2vw;
        left: -1.563vw;
    }
    .box3text > p:nth-child(1) {
        font-size: 4.167vw;
        font-weight: 900;
        color: white;
        font-family: "Montserrat";
        line-height: 3.438vw;
        margin: 0;
        text-transform: uppercase;
        width: 29.792vw;
        margin: auto;
    }
    .box4 {
        z-index: 1;
        position: absolute;
        bottom: -100vh;
        right: 5.417vw;
        width: fit-content;
        height: fit-content;
        opacity: 1;
        font-family: "Montserrat";
        transition: 1s;
    }
    .box4after {
        bottom: 2vw;
    }
    .box4text p:nth-child(1) {
        width: 29.115vw;
        /* position: absolute;
        left: 4.6vw;
        top: 0vw; */
        font-size: 3.125vw;
        font-weight: 800;
        color: white;
        line-height: 2.656vw;
        text-transform: uppercase;
        text-align: left;
    }
    .box4text p:nth-child(2) {
        /* width: 28.073vw; */
        /* position: absolute;
        left: 4.6vw;
        top: 0vw; */
        font-size: 1.042vw;
        font-weight: 400;
        color: white;
        line-height: 1.25vw;
    }
    .box4text p:nth-child(3) {
        width: 22.24vw;
        /* position: absolute;
        left: 4.6vw;
        top: 0vw; */
        font-size: 2.083vw;
        font-weight: 400;
        color: white;
        line-height: 2.5vw;
        text-align: right;
    }
    .box5 {
        position: absolute;
        top: 16.667vw;
        width: 29.115vw;
        height: fit-content;
        right: 5.729vw;
        font-family: "Montserrat";
        opacity: 0;
        transition: 1s;
    }
    .box5after {
        top: 32vw;
        opacity: 1;
    }
    .box5after2 {
        bottom: -17.333vw;
        transition: 0.5s;
    }
    .box5 p {
        font-size: 2.083vw;
        color: white;
        font-weight: 900;
        text-transform: uppercase;
        margin: 0;
    }
    .box6 {
        position: absolute;
        top: -15vw;
        width: 34.896vw;
        right: 4.323vw;
        font-family: "Montserrat";
        transition: 1s;
        text-align: center;
        color: white;
        text-transform: uppercase;
        transition: 1s;
    }
    .box6after {
        top: 13.125vw;
    }

    .box6 > p:nth-child(1) {
        font-size: 4.167vw;
        line-height: 3.542vw;
        font-weight: 900;
        margin: 0;
    }
    .box6 > p:nth-child(2) {
        font-size: 2.083vw;
        line-height: 1.771vw;
        font-weight: 200;
        margin: 0;
        text-transform: uppercase;
    }
    .box7 {
        position: absolute;
        bottom: -20vw;
        width: 33.6vw;
        right: 4.323vw;
        font-family: "Montserrat";
        transition: 1s;
        text-align: left;
        color: white;
        text-transform: uppercase;
        transition: 1s;
    }
    .box7after {
        bottom: 3.031vw;
    }

    .box7 > p:nth-child(1) {
        font-size: 3.125vw;
        line-height: 2.656vw;
        font-weight: 900;
        margin: 0;
        margin-bottom: 1.667vw !important;
    }
    .box7 > p:nth-child(2) {
        font-size: 1.25vw;
        line-height: 1.25vw;
        font-weight: 400;
        margin: 0;
    }
    .box8 {
        position: absolute;
        top: -36vw;
        width: 23.021vw;
        right: 10.26vw;
        font-family: "Montserrat";
        transition: 1s;
        text-align: left;
        color: white;
        transition: 0.8s;
    }
    .box8after {
        top: 10.885vw;
    }

    .box8 p:nth-child(1) {
        font-size: 3.125vw;
        line-height: 2.656vw;
        font-weight: 900;
        margin: 0;
        margin-bottom: 8.906vw !important;
        text-transform: uppercase;
    }
    .box8 p:nth-child(2) {
        font-size: 2.083vw;
        line-height: 2.083vw;
        font-weight: 400;
    }
    .box8 p:nth-child(3) {
        font-size: 2.083vw;
        line-height: 2.083vw;
        font-weight: 400;
        margin: 0;
    }
</style>
